import $ from 'jquery';

class StripTillToggleButton {
    constructor () {
        this.toggleButtonOutside = $('#toggle-button-outside');
        this.toggleButton = $('#toggle-button-inside');
        this.stripTill = $('#strip-till');
        this.noTill = $('#no-till');
        this.machinesStripTill = $('#machines-slider-strip-till');
        this.machinesNoTill = $('#machines-slider-no-till');
        this.events();
    }

    events(){
        this.toggleButtonOutside.on("click", this.toggleLogic.bind(this))
    }
    
    

    toggleLogic(){
        if(this.stripTill[0].classList.contains('toggle-active')){
            this.toggleButton[0].style.transform = 'translateX(-34px)';
            this.toggleButton[0].style.transitionDuration = '0.3s';
            this.toggleButton[0].style.transitionTimingFunction = 'ease-in-out';
            this.stripTill[0].classList.remove('toggle-active');
            this.noTill[0].classList.add('toggle-active');
            this.machinesStripTill[0].style = 'display: none';
            this.machinesNoTill[0].style = 'display: flex';
        }else{
            this.toggleButton[0].style.transform = 'translateX(0px)';
            this.toggleButton[0].style.transitionDuration = '0.3s';
            this.toggleButton[0].style.transitionTimingFunction = 'ease-in-out';
            this.noTill[0].classList.remove('toggle-active');
            this.stripTill[0].classList.add('toggle-active');
            this.machinesNoTill[0].style = 'display: none';
            this.machinesStripTill[0].style = 'display: flex';
        }

    }
}

export default StripTillToggleButton;